import { ChangeEventHandler, CSSProperties, FC, useRef } from "react"
import { cls } from "../../../../Shared/cls"
import { ToggleSwitchSlim, ToggleSwitchSlimRefProps } from "../ToggleSwitchSlim/ToggleSwitchSlim"
import style from "./ToggleSwitchSlimWithText.module.css"

export type Props = {
	text: string
	onChange?: ChangeEventHandler<HTMLInputElement>
	checked?: boolean
	className?: string
	styles?: CSSProperties
	textClassName?: string
	textStyles?: CSSProperties
	disabled?: boolean
}
export const ToggleSwitchSlimWithText: FC<Props> = ({
	text,
	onChange,
	checked,
	className,
	textClassName,
	styles,
	textStyles,
	disabled,
}) => {
	const toggleRef = useRef<ToggleSwitchSlimRefProps | null>(null)

	return (
		<div className={cls(style.wrapper, className, { [style.disabled]: disabled === true })} style={styles}>
			<ToggleSwitchSlim checked={checked} onChange={onChange} ref={toggleRef} />
			<span
				className={cls(style.text, textClassName)}
				style={textStyles}
				onClick={() => {
					toggleRef.current?.toggle()
				}}>
				{text}
			</span>
		</div>
	)
}
